<template>
  <sc-form :form="cteUploadForm" :rules="rules" @submit="uploadCTeFile">
    <template slot="fields" slot-scope="{ fields }">
      <div class="columns">
        <div class="column">
          <span class="sc-label-bigger">Escolha a transportadora</span>
          <sc-field label="Transportadora" prop="logisticProviderId" expanded>
            <sc-logistic-provider-dropdown
              @input="clearFieldsForCorreios(fields)"
              v-model="fields.logisticProviderId"
            />
          </sc-field>
        </div>
        <div class="column" v-show="fields.logisticProviderId !== 1">
          <span class="sc-label-bigger">Faça o upload dos arquivos CT-e</span>
          <sc-field
            label="Arquivo nos formatos .zip ou .rar"
            prop="ctesFiles"
            expanded
          >
            <sc-files-upload
              ref="ctesFilesUpload"
              v-bind="fileImporterOptions"
              @addfilestart="(file) => (fields.ctesFiles = file)"
              @removefile="() => (fields.ctesFiles = null)"
            />
          </sc-field>
        </div>
      </div>
    </template>

    <template slot="actions" slot-scope="{ isValid }">
      <router-link :to="{ name: 'pre-invoice-audit' }" class="button">
        Voltar
      </router-link>

      <sc-button text="Enviar CT-e" type="submit" theme="primary" />
    </template>
  </sc-form>
</template>
<script>
import {
  ScButton,
  ScField,
  ScFilesUpload,
  ScForm,
  ScLogisticProviderDropdown,
  ScSelect,
  ScUpload,
  ScUploadBox,
} from '@intelipost-js/secure-components';

import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations, mapActions } =
  createNamespacedHelpers('recon/cteUpload');

export default {
  name: 'sc-cte-upload-form',
  data() {
    return {
      rules: {
        logisticProviderId: [
          {
            trigger: 'input',
            validator(rule, value, callback) {
              const errors = [];

              if (!value) {
                errors.push(
                  new Error('Escolha uma transportadora', rule.field),
                );
                callback(errors);
              } else {
                callback();
              }
            },
          },
        ],
        ctesFiles: [
          {
            trigger: ['addfilestart', 'removefile'],
            type: ['object', 'null'],
            validator: (rule, value, callback, fields) => {
              const { logisticProviderId = null } = fields;
              const { file = null } =
                this.$refs.ctesFilesUpload.getFile() || {};
              const errors = [];

              if (logisticProviderId !== 1) {
                if (!file || !(file instanceof File)) {
                  errors.push(
                    new Error(
                      'Importe um arquivo de CT-e no formato .zip ou .rar',
                      rule.field,
                    ),
                  );
                  callback(errors);
                }

                if (file && file.size && file.size > 200000000) {
                  errors.push(
                    new Error('O arquivo deve ter no máximo 200 MB', rule.field),
                  );
                  callback(errors);
                }

                callback();
              }

              callback();
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(['loadingUploadForm', 'cteUploadForm']),
    ...mapMutations(['setUploadForm']),
    fileImporterOptions() {
      return {
        labelIdle:
          '<i class="fas fa-file-upload fa-2x fa-center"></i> Arraste o arquivo ou clique para enviar',
        maxFileSize: '200MB',
        acceptedFileTypes: [
          'application/zip',
          'application/x-zip',
          'application/x-zip-compressed',
          '.zip',
          'application/rar',
          'application/x-rar',
          'application/x-rar-compressed',
          'application/vnd.rar',
          '.rar',
        ].join(','),
        allowMultiple: false,
      };
    },
  },
  methods: {
    ...mapActions(['uploadCTeFile']),
    clearFieldsForCorreios(fields) {
      if (fields.logisticProviderId === 1) {
        this.$refs.ctesFilesUpload.removeFiles();
        Object.assign(fields, {
          ctesFiles: null,
        });
      }
    },
  },
  components: {
    ScButton,
    ScField,
    ScFilesUpload,
    ScForm,
    ScLogisticProviderDropdown,
    ScSelect,
    ScUpload,
    ScUploadBox,
  },
};
</script>
<style lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
.sc-label-bigger {
  font-size: 20px;
}
.fa-center {
  line-height: inherit !important;
  vertical-align: middle;
}

.filepond--root {
  margin-bottom: 0;
  height: 4.6em;
}

.filepond--panel-root {
  border-radius: 0.5em;
  border: 1px dashed #000000;
}

.filepond--drop-label {
  transform: translate3d(0, -10px, 0) !important;
  label {
    font-size: 1.2em;
    i {
      color: $primary;
    }
  }
}

.fa-center {
  line-height: inherit !important;
  vertical-align: middle;
  margin-right: 0.5em;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/cte-upload/components/sc-cte-upload-form/ScCteUploadForm.vue